import { useEffect } from 'react';
import { req } from '../@api/request';

const FRONT_VERSION = Number(process.env.REACT_APP_VERSION);

export default function VersionChecker() {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const { data } = await req.get('/version');
        if (
          Number(data.data.version) &&
          Number(data.data.version) !== FRONT_VERSION
        ) {
          window.location.reload();
        }
      } catch (err) {
        console.error('버전 체크 실패:', err);
      }
    };

    checkVersion();

    const interval = setInterval(checkVersion, 60 * 1000); // 1분마다 체크

    return () => clearInterval(interval);
  }, []);

  return null;
}
